"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.processing.done': 'Completato',
    'avatar.processing.is_processing': 'In elaborazione',
};
